import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class AuthService {
  get isAuthed$(): Observable<boolean> {
    return of(false);
  }
}
